import React from 'react';
import PropTypes from 'prop-types';

import OutputText from '@ey/canvascoreservices/OutputText';

import {labels} from '../../../../../../../util/utils';
import {RECIPIENTS_SELECTED_LIST} from '../utils/constants';

import setUserList from './setUserList';
import StyledTable from './StyledTable';

import CommonContactTable from '../../../../../../Common/ContactTable';
import columns from '../../../../../../Common/ContactTable/columns';

const RecipientBulk = ({values, errors, handleChange, handleSubmit, handleReset, isFormValid}) => {
	const title = labels.selectedContacts;
	let OutputTextProps = {size: 'L'};
	const selectedContacts = values[RECIPIENTS_SELECTED_LIST];

	const handleDelete = (id) => {
		const newList = values.recipientsSelectedList.filter((item) => item !== id);
		handleChange(RECIPIENTS_SELECTED_LIST, newList);
	};

	const renderTable = () => {
		const data = setUserList(values).map((contact) => ({...contact, id: contact.userId}));
		const props = {
			tableConfig: {
				data,
				columns: columns(labels, {handleDelete}).generateMessage,
				pagination: true,
				labels: {
					emptyMessage: labels.thereIsNoDataToDisplay,
					show: labels.show,
					first: labels.firstPage,
					last: labels.lastPage,
					previous: labels.prevPage,
					next: labels.nextPage,
					yesLabel: labels.yes,
					noLabel: labels.no,
					scrollColNext: labels.viewMoreColumns,
					scrollColPrev: labels.viewMoreColumns
				},
				className: 'ContactTable'
			}
		};

		return <CommonContactTable {...props} />;
	};

	return (
		<div className="contact">
			<OutputText {...OutputTextProps}>{title}</OutputText>
			<StyledTable hasSelection={selectedContacts?.length > 0}>{renderTable()}</StyledTable>
		</div>
	);
};

RecipientBulk.propTypes = {};

export default RecipientBulk;
